import React from "react";

import { ConfirmationBox, WarningBox } from "@components/cards/messageBox";
import { STATUS_CONFIG } from "@utils/quoteStatusHelpers";
import { utcDateTimeExpressedInLocalTimeZone } from "@utils/misc/functions";

type Props = {
  status: string;
  zohoSignQuoteDetail: any;
  customerName: string;
};

export default function QuoteStatusBanner({
  status,
  zohoSignQuoteDetail,
  customerName,
}: Props) {
  const config = STATUS_CONFIG[status];
  if (!config) return null;

  const date = utcDateTimeExpressedInLocalTimeZone(
    zohoSignQuoteDetail?.[config.dateField],
    "long",
    "long"
  );

  const message = config.getMessage(customerName, date);
  const Component =
    config.component === "confirmation" ? ConfirmationBox : WarningBox;

  return <Component testId={config.testId} message={message} />;
}
